import React, { FC, useMemo } from 'react';
import Style from './Spinner.style';

type TProps = {
  className?: string;
  minHeight?: number;
};

export const Spinner: FC<TProps> = ({ className = '', minHeight }) => {
  const style = useMemo(() => {
    const _style: React.CSSProperties = {};
    if (minHeight) {
      _style.minHeight = `${minHeight}px`;
    }
    return _style;
  }, [minHeight]);

  return <Style className={`spinner ${className}`} style={style} />;
};
